type TimeoutReturnType = ReturnType<typeof setTimeout>;
export const debounce = <F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  wait = 300,
  immediate?: boolean,
) => {
  let timeout: TimeoutReturnType | null = null;

  const debounced = function (this: unknown, ...fnArgs: Parameters<F>) {
    const callNow = immediate && !timeout;

    timeout && clearTimeout(timeout);

    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) {
        func.apply(this, fnArgs);
      }
    }, wait);

    if (callNow) func.apply(this, fnArgs);
  };

  debounced.cancel = () => {
    clearTimeout(timeout!);
    timeout = null;
  };

  return debounced;
};
